export default ({ request }) => ({
  fabricStockInListApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockIn/list',
      method: 'post',
      data,
    })
  },
  fabricStockInDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockIn/detail',
      method: 'post',
      data,
    })
  },
  fabricStockInSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockIn/save',
      method: 'post',
      data,
    })
  },
  fabricStockInAddApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockIn/add',
      method: 'post',
      data,
    })
  },
  fabricStockInRequestSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockIn/requestSave',
      method: 'post',
      data,
    })
  },
  fabricStockInDelApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockIn/del',
      method: 'post',
      data,
    })
  },
  fabricStockInAuditApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockIn/audit',
      method: 'post',
      data,
    })
  },
  fabricStockInChangeRequestStatusApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockIn/change/requestStatus',
      method: 'post',
      data,
    })
  },
  fabricStockInDetailByColorApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockIn/detailByColor',
      method: 'post',
      data,
    })
  }
})
